import { sleep } from '../../utils/utils';
import { VALIDATION_STATES } from '../../utils/constants';
export default async function hasErrors(form) {
  if (!form) {
    return false;
  }

  //Touch all fields in form
  form.querySelectorAll('input, select, textarea').forEach(el => {
    el.dispatchEvent(new Event('focus'));
    el.dispatchEvent(new Event('blur'));
  });

  //Give the browser time to make updates during field validation
  await sleep(50);

  //Field level validation
  return form.querySelectorAll(`*[data-valid="${VALIDATION_STATES.error}"]`).length > 0;
}